import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ILocale } from './models';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-language-pref',
  template: `
    <div class="container" fxLayout="column" fxLayoutAlign="start">
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center">
        <mat-icon aria-hidden="false" aria-label="close icon" class="close-icon" mat-dialog-close>close</mat-icon>
      </div>
      <div fxLayout="row" fxFill fxFlex="100" fxLayoutAlign="start center">
        <form [formGroup]="form" class="full-width">
          <h4 class="fw-500">
            {{ 'LOCALE.PREFERENCE.SELECT-DEFAULT-LANGUAGE' | translate }}
          </h4>
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'LOCALE.PREFERENCE.SELECT-DEFAULT-LANGUAGE' | translate }}</mat-label>
            <mat-select formControlName="language">
              @for (language of languages; track language) {
                <mat-option [value]="language.id"> {{ language.name | translate }} ({{ language.id }}) </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
      <div fxLayout="row" fxFill fxFlex="100" fxLayoutAlign="end center">
        <button mat-flat-button mat-dialog-close>
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button [disabled]="!form.valid" mat-flat-button color="primary" (click)="closeDialog()">
          {{ 'COMMON.CONFIRM' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .close-icon {
        cursor: pointer;
      }
    `,
  ],
  imports: [
    MatIcon,
    MatDialogClose,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatButton,
    TranslateModule,
  ],
})
export class PreferenceDialog implements OnInit {
  form!: UntypedFormGroup;
  label = 'Reason*';
  languages: ILocale[] = [
    { id: 'en-GB', name: 'LOCALE.LANGUAGES.ENGLISH' },
    { id: 'sw', name: 'LOCALE.LANGUAGES.SWAHILI' },
    { id: 'fr-CD', name: 'LOCALE.LANGUAGES.FRENCH' },
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<PreferenceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      language: ['', [Validators.required]],
    });
  }

  closeDialog() {
    this.dialogRef.close({ language: this.form.controls.language.value });
  }
}
